

























































































































































































































































































































































































































































































































import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { PrimaryContactForThisEventorClaim } from '@/common/ClaimsForm';
import jQuery from 'jquery';
import moment from 'moment-timezone';

@Component({
	name: 'NewClaimsFormSingle',
	components: {},
})
export default class NewClaimsFormSingle extends Vue {
	@Prop() public claim: any;
	public claimData: any;
	public primaryContactForThisEventorClaim: any;
	public involvedInsuredsHealthCareProviders: any;
	public informationAboutThePatientOrClaimantInvolved: any;
	public informationAboutTheClaimIncident: any;
	public claimantPlantiffAttorneyInformation: any;
	public insuredsPolicyInformation: any;

	private created() {
		this.claimData = this.claim.claim_data;
		this.insuredsPolicyInformation = this.claim.claim_data.insuredsPolicyInformation;
		this.primaryContactForThisEventorClaim = this.claimData.primaryContactForThisEventorClaim;
		this.involvedInsuredsHealthCareProviders = this.claimData.involvedInsuredsHealthCareProviders;
		this.informationAboutThePatientOrClaimantInvolved = this.claimData.informationAboutThePatientOrClaimantInvolved;
		this.informationAboutTheClaimIncident = this.claimData.informationAboutTheClaimIncident;
		this.claimantPlantiffAttorneyInformation = this.claimData.claimantPlantiffAttorneyInformation;

		// tslint:disable-next-line:prefer-for-of
		for (let i = 0; i < this.involvedInsuredsHealthCareProviders.providers.length; i++) {
			const provider = this.involvedInsuredsHealthCareProviders.providers[i];
			if (provider.sameAddress === 'group' && provider.sameAddressAs) {
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].streetAddress = this.involvedInsuredsHealthCareProviders.group.streetAddress;
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].buildingOrganization = this.involvedInsuredsHealthCareProviders.group.buildingOrganization;
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].suiteAptUnit = this.involvedInsuredsHealthCareProviders.group.suiteAptUnit;
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].city = this.involvedInsuredsHealthCareProviders.group.city;
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].state = this.involvedInsuredsHealthCareProviders.group.state;
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].zipcode = this.involvedInsuredsHealthCareProviders.group.zipcode;
			}
			if (provider.sameContact === 'group' && provider.sameContactAs) {
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].emailAddress = this.involvedInsuredsHealthCareProviders.group.emailAddress;
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].phoneNumber = this.involvedInsuredsHealthCareProviders.group.phoneNumber;
				this.involvedInsuredsHealthCareProviders.providers[
					i
				].phonePreference = this.involvedInsuredsHealthCareProviders.group.phonePreference;
			}
		}

		const primaryContactForThisEventorClaim: PrimaryContactForThisEventorClaim = this.claimData
			.primaryContactForThisEventorClaim;
		const sameAsUser: string | undefined = primaryContactForThisEventorClaim.sameAsUser;
		if (sameAsUser) {
			if (sameAsUser === 'group') {
				const groupData = this.involvedInsuredsHealthCareProviders.group;

				this.primaryContactForThisEventorClaim.emailAddress = groupData.emailAddress;
				this.primaryContactForThisEventorClaim.firstName = groupData.groupName;
				this.primaryContactForThisEventorClaim.lastName = groupData.lastName;
				this.primaryContactForThisEventorClaim.phoneNumber = groupData.phoneNumber;
				this.primaryContactForThisEventorClaim.phonePreference = groupData.phonePreference;
				this.primaryContactForThisEventorClaim.streetAddress = groupData.streetAddress;
				this.primaryContactForThisEventorClaim.buildingOrganization =
					groupData.buildingOrganization;
				this.primaryContactForThisEventorClaim.suiteAptUnit = groupData.suiteAptUnit;
				this.primaryContactForThisEventorClaim.city = groupData.city;
				this.primaryContactForThisEventorClaim.state = groupData.state;
				this.primaryContactForThisEventorClaim.zipcode = groupData.zipcode;
			} else if (sameAsUser.includes('provider')) {
				const getProviderIndex = sameAsUser.replace('provider', '');

				const providerData = this.claimData.involvedInsuredsHealthCareProviders.providers[
					getProviderIndex
				];
				this.primaryContactForThisEventorClaim.emailAddress = providerData.emailAddress;
				this.primaryContactForThisEventorClaim.firstName = providerData.firstName;
				this.primaryContactForThisEventorClaim.lastName = providerData.lastName;
				this.primaryContactForThisEventorClaim.phoneNumber = providerData.phoneNumber;
				this.primaryContactForThisEventorClaim.phonePreference =
					providerData.phonePreference;
				this.primaryContactForThisEventorClaim.streetAddress = providerData.streetAddress;
				this.primaryContactForThisEventorClaim.buildingOrganization =
					providerData.buildingOrganization;
				this.primaryContactForThisEventorClaim.suiteAptUnit = providerData.suiteAptUnit;
				this.primaryContactForThisEventorClaim.city = providerData.city;
				this.primaryContactForThisEventorClaim.state = providerData.state;
				this.primaryContactForThisEventorClaim.zipcode = providerData.zipcode;
			}
		}

		if (
			this.informationAboutTheClaimIncident &&
			this.informationAboutTheClaimIncident.sameAddress
		) {
			const sameAddress = this.informationAboutTheClaimIncident.sameAddress;

			if (sameAddress === 'group') {
				const groupData = this.involvedInsuredsHealthCareProviders.group;

				this.informationAboutTheClaimIncident.emailAddress = groupData.emailAddress;
				this.informationAboutTheClaimIncident.firstName = groupData.firstName;
				this.informationAboutTheClaimIncident.lastName = groupData.lastName;
				this.informationAboutTheClaimIncident.phoneNumber = groupData.phoneNumber;
				this.informationAboutTheClaimIncident.phonePreference = groupData.phonePreference;
				this.informationAboutTheClaimIncident.streetAddress = groupData.streetAddress;
				this.informationAboutTheClaimIncident.buildingOrganization =
					groupData.buildingOrganization;
				this.informationAboutTheClaimIncident.suiteAptUnit = groupData.suiteAptUnit;
				this.informationAboutTheClaimIncident.city = groupData.city;
				this.informationAboutTheClaimIncident.state = groupData.state;
				this.informationAboutTheClaimIncident.zipcode = groupData.zipcode;
			} else if (sameAddress.includes('provider')) {
				const getProviderIndex = sameAddress.replace('provider', '');

				if (
					this.involvedInsuredsHealthCareProviders &&
					this.involvedInsuredsHealthCareProviders.providers &&
					this.involvedInsuredsHealthCareProviders.providers[getProviderIndex]
				) {
					const providerData = this.involvedInsuredsHealthCareProviders.providers[
						getProviderIndex
					];
					this.informationAboutTheClaimIncident.emailAddress = providerData.emailAddress;
					this.informationAboutTheClaimIncident.firstName = providerData.firstName;
					this.informationAboutTheClaimIncident.lastName = providerData.lastName;
					this.informationAboutTheClaimIncident.phoneNumber = providerData.phoneNumber;
					this.informationAboutTheClaimIncident.phonePreference =
						providerData.phonePreference;
					this.informationAboutTheClaimIncident.streetAddress =
						providerData.streetAddress;
					this.informationAboutTheClaimIncident.buildingOrganization =
						providerData.buildingOrganization;
					this.informationAboutTheClaimIncident.suiteAptUnit = providerData.suiteAptUnit;
					this.informationAboutTheClaimIncident.city = providerData.city;
					this.informationAboutTheClaimIncident.state = providerData.state;
					this.informationAboutTheClaimIncident.zipcode = providerData.zipcode;
				}
			}
		}

		// claimant info
		if (this.informationAboutThePatientOrClaimantInvolved.residentialAddressSameAsPatient) {
			this.informationAboutThePatientOrClaimantInvolved.claimant.streetAddress = this.informationAboutThePatientOrClaimantInvolved.streetAddress;
			this.informationAboutThePatientOrClaimantInvolved.claimant.buildingOrganization = this.informationAboutThePatientOrClaimantInvolved.buildingOrganization;
			this.informationAboutThePatientOrClaimantInvolved.claimant.suiteAptUnit = this.informationAboutThePatientOrClaimantInvolved.suiteAptUnit;
			this.informationAboutThePatientOrClaimantInvolved.claimant.city = this.informationAboutThePatientOrClaimantInvolved.city;
			this.informationAboutThePatientOrClaimantInvolved.claimant.state = this.informationAboutThePatientOrClaimantInvolved.state;
			this.informationAboutThePatientOrClaimantInvolved.claimant.zipcode = this.informationAboutThePatientOrClaimantInvolved.zipcode;
		}
		if (this.informationAboutThePatientOrClaimantInvolved.contactInformationSameAsPatient) {
			this.informationAboutThePatientOrClaimantInvolved.claimant.streetAddress = this.informationAboutThePatientOrClaimantInvolved.claimant.emailAddress = this.informationAboutThePatientOrClaimantInvolved.emailAddress;
			this.informationAboutThePatientOrClaimantInvolved.claimant.phoneNumber = this.informationAboutThePatientOrClaimantInvolved.phoneNumber;
			this.informationAboutThePatientOrClaimantInvolved.claimant.phonePreference = this.informationAboutThePatientOrClaimantInvolved.phonePreference;
		}
	}

	private downloadFile(file) {
		window.location.assign(file);
	}

	private formatDate(date) {
		return moment.tz( date, 'America/Chicago' ).format( 'MM/D/YYYY hh:mma' );
	}

	private copyText() {
		const copyText = jQuery('#webId');

		const el = document.createElement('textarea');
		el.value = copyText.text();
		el.setAttribute('readonly', '');
		el.style.position = 'absolute';
		el.style.left = '-9999px';
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	}
}
